
export const ACTION_HIDDEN_MOD = "Скрыть мод"